// Copyright 2026, Imprivata, Inc.  All rights reserved.

import './CharacterCountHelper.less';

interface CharacterCountHelperProps {
  text: string;
  className?: string;
}

const COUNTER_PATTERN = /^(.*?)\s*(\(\d+\/\d+\))\s*$/;

const CharacterCountHelper = ({ text, className }: CharacterCountHelperProps) => {
  const match = COUNTER_PATTERN.exec(text);

  return (
    <div
      className={['character-count-helper', className].filter(Boolean).join(' ')}
    >
      <span>{match ? match[1] : text}</span>
      {match && <span className="character-count-helper__count">{match[2]}</span>}
    </div>
  );
};

export default CharacterCountHelper;
